var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    { staticClass: "index-table", class: { "in-modal-table": _vm.inModal } },
    [
      _c("thead", [
        _c(
          "tr",
          { staticClass: "no-hover" },
          [
            _c("th", [_vm._v("Коэффициент")]),
            _vm._v(" "),
            _c("th", { staticClass: "grey-column" }, [_vm._v("Норма, %")]),
            _vm._v(" "),
            _vm.years.length
              ? _vm._l(_vm.years, function (y, i) {
                  return _c("th", { key: i }, [_vm._v(_vm._s(y))])
                })
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.list, function (e, i) {
          return _c(
            "tr",
            { key: i },
            [
              _c(
                "td",
                {
                  staticClass: "cursor-help",
                  class: { "fw-bold": _vm.inModal },
                  attrs: { title: e.descr },
                },
                [
                  _vm._v(
                    "\n                " + _vm._s(e.label) + "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("td", { staticClass: "grey-column" }, [
                _vm._v(_vm._s(e.normalValue)),
              ]),
              _vm._v(" "),
              _vm._l(_vm.years, function (y, i) {
                return _c(
                  "td",
                  {
                    key: i,
                    class: _vm.checkValue(e.key, _vm.targetObj[y][e.key])
                      ? "green"
                      : "red",
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.targetObj[y][e.key]
                            ? _vm.targetObj[y][e.key]
                            : "—"
                        ) +
                        "\n            "
                    ),
                  ]
                )
              }),
            ],
            2
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }